// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1mYtZ","title":"ClientInsurance_title__2PKRt","itemText":"ClientInsurance_itemText__32hEO"};